import TabelaGerenciaPermissoes from "../../components/TabelaGerenciaPermissoes/TabelaGerenciaPermissoes"
import { useEffect, useState } from "react"
import FiltrosGerenciaPermissoes from "../../components/FiltrosGerenciaPermissoes/FiltrosGerenciaPermissoes"
import { get } from "../../services/api"
import AdicionarNovaPermissao from "../../components/AdicionarNovaPermissao/AdicionarNovaPermissao"
import AdminErrorMessage from "../../components/AdminErrorMessage/AdminErrorMessage"
import NotifierPopup from "../../components/NotifierPopup/NotifierPopup"

function PermissoesAdm() {
    const [ permissoes, setPermissoes ] = useState(null)
    const [ authTokenState, setAuthToken ] = useState(null)
    const [ page, setPage ] = useState(1)
    const [ numberOfPages, setNumberOfPage ] = useState(1)
    const [ error, setError ] = useState({ message: undefined, isActive: false })
    const [ filtros, setFiltros ] = useState('')
    const [ isTableLoading, setTableLoading ] = useState(true)
    const maxPerPage = 15

    const [ setorOptions, setSetorOptions ] = useState([])
    const [ papelOptions, setPapelOptions ] = useState([])

    const [ notify, setNotify ] = useState({
        isActive: false,
        isSuccessful: undefined,
        message: undefined
    })

    async function setPermissoesWithRequest(authToken, queryParams='', newPage=undefined) {
        try {
            const permissoes = await get(`/admin/permissoes?page=${typeof newPage === 'undefined' ? page : newPage}&max=${maxPerPage}${queryParams}`, null, authToken)
            setPermissoes(permissoes.data)
            setNumberOfPage(permissoes.numberOfPages)
            setTableLoading(false)
        } catch (error) {
            if (error.response) {
                console.error('Erro na resposta do servidor:', error.response.data);
            } else if (error.request) {
                console.error('Sem resposta do servidor:', error.request);
            } else {
                console.error('Erro durante a configuração da requisição:', error.message);
            }
        }
    }

    async function setSetorOptionsWithRequest(authToken) {
        try {
            const setorOptions = await get("/admin/setores", null, authToken)
            setSetorOptions(setorOptions)
        } catch (error) {
            if (error.response) {
                console.error('Erro na resposta do servidor:', error.response.data);
            } else if (error.request) {
                console.error('Sem resposta do servidor:', error.request);
            } else {
                console.error('Erro durante a configuração da requisição:', error.message);
            }
        }
    }

    async function setPapelOptionsWithRequest(authToken) {
        try {
            const papelOptions = await get("/admin/permissoes/papeis", null, authToken)
            setPapelOptions(papelOptions)
        } catch (error) {
            if (error.response) {
                console.error('Erro na resposta do servidor:', error.response.data);
            } else if (error.request) {
                console.error('Sem resposta do servidor:', error.request);
            } else {
                console.error('Erro durante a configuração da requisição:', error.message);
            }
        }
    }

    useEffect(() => {
        const authToken = localStorage.getItem("adminToken")

        if(authToken != null) {
            setAuthToken(authToken)
            setPermissoesWithRequest(authToken)
            setSetorOptionsWithRequest(authToken)
            setPapelOptionsWithRequest(authToken)
        }
    }, [])

    return (
        <> 
            {error.isActive && <AdminErrorMessage error={error} setError={setError} />}
            {notify.isActive && (
                <NotifierPopup notify={notify} setNotify={setNotify} />
            )}

            <AdicionarNovaPermissao authToken={authTokenState} setError={(message) => {
                setError({ message: message, isActive: true })
            }} refetchPermissoes={() => {
                setSetorOptionsWithRequest(authTokenState)
                setPapelOptionsWithRequest(authTokenState)
                setTableLoading(true)
                setPermissoesWithRequest(authTokenState, filtros)
            }} setorOptions={setorOptions} papelOptions={papelOptions}
                setNotifier={(isSuccess, message) => setNotify({
                    isActive: true,
                    isSuccessful: isSuccess,
                    message: message
                })}
            />

            <FiltrosGerenciaPermissoes setPermissoes={(queryParams) => {
                    setFiltros(queryParams)
                    setPage(1)
                    setTableLoading(true)
                    setPermissoesWithRequest(authTokenState, queryParams, 1)
                }} />
            <TabelaGerenciaPermissoes authToken={authTokenState} page={page} numberOfPages={numberOfPages} setPage={(newPage) => {
                setPage(newPage)
                setTableLoading(true)
                setPermissoesWithRequest(authTokenState, '', newPage)
            }} permissoes={permissoes} setPermissoes={setPermissoes} refetchPermissoes={() => {
                setTableLoading(true)
                setPermissoesWithRequest(authTokenState, filtros)
            }} isTableLoading={isTableLoading} refetchOptions={() => {
                setSetorOptionsWithRequest(authTokenState)
                setPapelOptionsWithRequest(authTokenState)
            }} />
        </>
    )
}

export default PermissoesAdm

